
import { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay";

import axios from "../../../axios/axios";
import moment from "moment";
import { DATE_TIME_FORMAT } from "../../../constants/constants";
import DataTable from "react-data-table-component";
import { useParams } from "react-router-dom";
import { Button, Dropdown, Form } from "react-bootstrap";
import { ThreeDot } from "../../../assets/images";
import { message } from "antd";
import { CSVLink } from "react-csv";
import Select from "react-select";

const AllCorporateMemberList = () => {
    const { id } = useParams();
    const [loader, setLoader] = useState(false);
    const [members, setMember] = useState([]);
    const [total, setTotal] = useState(0);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [csvData, setCsvData] = useState([]);
    const [clientList, setClientList] = useState([]);
    const [filter, setFilter] = useState({
        search: "",
        startDate: "",
        endDate: "",
        client: "",
    });
    const [passwordShowHide, setpasswordShowHide] = useState(null);
    const [arriviaPasswordShowHide, setArriviaPasswordShowHide] = useState(null);
    const [search, setSearch] = useState({ search: "", startDate: "", endDate: "", client: {} });
    useEffect(() => {
        getMembers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [limit, page, search]);

    useEffect(() => {
        getClientList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getMembers = () => {
        const config = {
            headers: { Authorization: `Bearer ${localStorage.getItem("AuthToken")}` },
        };

        setLoader(true);

        axios.get(
            `/advantage-member/get-all-corporate-member-admin?page=${page}&limit=${limit}&search=${search?.search}&startDate=${search?.startDate}&endDate=${search?.endDate}&client=${search?.client?.value || ""}`,
            config
        )
            .then((res) => {
                setLoader(false);
                if (res.data.status) {
                    setMember(res.data.data);
                    setTotal(res.data.pagination?.total);
                }
            })
            .catch((err) => {
                setLoader(false);
                console.error(err);
            });
    };
    const getClientList = () => {
        const config = {
            headers: { Authorization: `Bearer ${localStorage.getItem("AuthToken")}` },
        };



        axios.get(
            `/get-all-corporate-tvi-users`,
            config
        )
            .then((res) => {

                if (res.data.status) {
                    // setClientList(res.data.data);
                let copUser =  res.data?.data?.map((item) => {
                        return { value: item?.userId, label: `${item.name} (${item.userEmail} , ${item.username})` }
                    })
                    setClientList(copUser);
                }
            })
            .catch((err) => {

                console.error(err);
            });
    };


    const toggleStatus = (email, type, clientId) => {
        setLoader(true);
        axios
            .patch(`/advantage-member/admin-client-member-active-inactive/${type}/${email}/${clientId}`)
            .then((res) => {
                setLoader(false);
                if (res.data.status) {
                    message.success(res.data.message);
                    getMembers();
                } else {
                    message.error(res.data.message);
                }
            })
            .catch((err) => {
                setLoader(false);
                console.error(err);
            });
    };
    const showHidePasswordFun = (id) => {
    setpasswordShowHide(id);
  };
    const showHideArriviaPasswordFun = (id) => {
    setArriviaPasswordShowHide(id);
  };
    const columns = [
        {
            name: "Member Name",
            selector: (row) => row.memberName,
            sortable: true,
        },
        {
            name: "Member Email",
            selector: (row) => row.memberEmail,
            sortable: true,
        },
        {
            name: "Member Username",
            selector: (row) => row.memberUserName,
            sortable: true,
        },
        {
            name: "Client Name",
            selector: (row) => row.clientName,
            sortable: true,
        },
        {
            name: "Client Email",
            selector: (row) => row.clientEmail,
            sortable: true,
        },
        {
            name: "Client Username",
            selector: (row) => row.clientUserName,
            sortable: true,
        },

        {
            name: "Created At",
            selector: (row) => moment(row.createdAt).format(DATE_TIME_FORMAT),
            sortable: true,
        },
        {
            name: "Status",
            selector: (row) => row.statusType,
            sortable: true,
        },
          {
      name: "Password",
      selector: (row) => (
        row?.isPasswordShow ? (
        <div>
          {passwordShowHide === row?.corporateMemberUserId ? (
            <>
              <span>{row?.passwordRaw}</span>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHidePasswordFun(null);
                }}
              >
                Hide
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHidePasswordFun(row.corporateMemberUserId);
                }}
              >
                Show
              </button>
            </>
          )}
        </div>
        ):(
            <span>N/A</span>
        )
      ),
      sortable: true,
      width: "130px",
      wrap: true
    },
          {
      name: "Arrivia Password",
      selector: (row) => (
        row?.arriviaPassword ? (
        <div>
          {arriviaPasswordShowHide === row?.corporateMemberUserId ? (
            <>
              <span>{row?.arriviaPassword}</span>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHideArriviaPasswordFun(null);
                }}
              >
                Hide
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHideArriviaPasswordFun(row.corporateMemberUserId);
                }}
              >
                Show
              </button>
            </>
          )}
        </div>
        ):(
            <span>N/A</span>
        )
      ),
      sortable: true,
      width: "130px",
      wrap: true
    },
        {
            name: "Action",
            selector: (row) => (
                <Dropdown drop="down" className="select_box_preassigneds">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                        <img src={ThreeDot} alt="Action" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <div
                            className="dropdown-item"
                            role="button"
                            onClick={() => {
                                toggleStatus(row?.memberUserName, row?.status ? "inactive" : "active", row?.clientId);
                            }}
                        >
                            {row?.status ? "Inactive" : "Active"}
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
            ),
            width: "200px",
        },
    ];
    const customStyles = {
        header: {
            style: {
                minHeight: "56px",
            },
        },
        headRow: {
            style: {
                borderTopStyle: "solid",
                borderTopWidth: "1px",
            },
        },
        headCells: {
            style: {
                "&:not(:last-of-type)": {
                    borderRightStyle: "solid",
                    borderRightWidth: "1px",
                },
                fontSize: "17px",
                color: "#004aad",
            },
        },

        cells: {
            style: {
                "&:not(:last-of-type)": {
                    borderRightStyle: "solid",
                    borderRightWidth: "1px",
                },
                fontSize: "16px",
            },
        },
    };

    const headersForAdv = [
        { label: "Member Name", key: "memberName" },
        { label: "Member Email", key: "memberEmail" },
        { label: "Member Username", key: "memberUserName" },
        { label: "Client Name", key: "clientName" },
        { label: "Client Email", key: "clientEmail" },
        { label: "Client Username", key: "clientUserName" },
        { label: "Created At", key: "createdAt" },
        { label: "Status", key: "statusType" },
    ];
    const downloadCsv = () => {
        setLoader(true);
        axios.get(
            `/advantage-member/get-all-corporate-member-admin-csv-download?search=${search?.search}&startDate=${search?.startDate}&endDate=${search?.endDate}&client=${search?.client?.value || ""}`,
        )
            .then((res) => {
                if (res.data.status) {
                    const formatData = res.data.data?.map(item => {
                        item.createdAt = moment(item.createdAt).format(DATE_TIME_FORMAT);
                        return item;
                    });
                    setCsvData(formatData);
                    setLoader(false);
                    setTimeout(() => {
                        document.getElementById("csv-download-link").click();
                    }, 100);
                }
            })
            .catch((err) => {
                console.error(err);
            });
    };
    return (
        <LoadingOverlay active={loader} spinner text="Loading ...">
            <section className="right_cont">

                <div className="right_banner_banner_cnt">
                    <div className="certificate-heading">
                        <h2>All Member's List</h2>
                    </div>
                    <div className="mt-3 row mb-3">
                        <div className="col-md-6">
                            <label htmlFor="client">Client Name</label>
                            {/* <Form.Select
                                className="form-control"
                                name="client"
                                value={filter.client}
                                onChange={(e) => setFilter({ ...filter, client: e.target.value })}
                            >
                                <option value="">Select Client Name</option>
                                {clientList.map((client) => (
                                    <option value={client.userId}>
                                        {client.name} ({client.userEmail} , {client.userNameAttr})
                                    </option>
                                ))}
                            </Form.Select> */}

                            <Select
                                options={clientList}
                                name="client"
                                value={filter.client}
                                onChange={(e) => setFilter({ ...filter, client:e })}
                                placeholder="Select Client Name"
                            />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="name">Member Name, Email, Username</label>
                            <Form.Control
                                type="text"
                                name="search"
                                value={filter.search}
                                onChange={(e) => setFilter({ ...filter, search: e.target.value })}
                                placeholder="Search by name or email or username"
                            />
                        </div>
                        <div className="col-md-5">
                            <label htmlFor="startDate">Start Date</label>
                            <Form.Control
                                type="date"
                                value={filter.startDate}
                                onChange={(e) => setFilter({ ...filter, startDate: e.target.value })}
                                name="startDate"
                            />
                        </div>
                        <div className="col-md-5">
                            <label htmlFor="endDate">End Date</label>
                            <Form.Control
                                type="date"
                                value={filter.endDate}
                                onChange={(e) => setFilter({ ...filter, endDate: e.target.value })}
                                name="endDate"
                            />
                        </div>
                        <div className="col-md-1 mt-4">
                            <Button
                                onClick={() => {
                                    setSearch({ ...filter });
                                    setPage(1);
                                }}
                            >
                                Search
                            </Button>
                        </div>
                        <div className="col-md-1 mt-4">
                            <Button
                                variant="dark"
                                onClick={() => {
                                    setFilter({ search: "", startDate: "", endDate: "", client: "" });
                                    setSearch({ search: "", startDate: "", endDate: "", client: "" });
                                    setPage(1);
                                }}
                            >
                                Clear
                            </Button>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-md-12 text-right">
                            <Button className="btn btn-primary" onClick={downloadCsv}>
                                Download CSV
                            </Button>

                            <CSVLink
                                data={csvData}
                                headers={headersForAdv}
                                filename={`corporate-member_${Date.now()}.csv`}
                                className="hidden"
                                id="csv-download-link"
                                target="_blank"
                            />
                        </div>
                    </div>
                    <div className="cert_det_inner">
                        <DataTable
                            columns={columns}
                            data={members}
                            highlightOnHover
                            pagination
                            striped
                            responsive
                            paginationServer
                            paginationTotalRows={total}
                            customStyles={customStyles}
                            subHeaderAlign="right"
                            paginationPerPage={limit}
                            paginationRowsPerPageOptions={[10, 20, 50]}
                            onChangePage={(newPage) => setPage(newPage)}
                            className={members.length === 1 ? "search_state" : ""}
                            onChangeRowsPerPage={(newLimit) => {
                                setLimit(newLimit);
                                setPage(1);
                            }}
                        />
                    </div>
                </div>
            </section>
        </LoadingOverlay>
    );
};

export default AllCorporateMemberList;
